import { render } from "./BatchSummaryComponent.vue?vue&type=template&id=154d2e9d&scoped=true"
import script from "./BatchSummaryComponent.vue?vue&type=script&lang=js"
export * from "./BatchSummaryComponent.vue?vue&type=script&lang=js"

import "./BatchSummaryComponent.vue?vue&type=style&index=0&id=154d2e9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154d2e9d"]])

export default __exports__